// Helper to check if we should bypass authentication on a per-request basis
export function shouldBypassAuth(reqUrl) {
  try {
    const base =
      typeof window !== 'undefined'
        ? window.location.origin
        : 'http://localhost'
    const u = new URL(reqUrl || '', base)

    // Never bypass for backend API calls
    const isBackendApi =
      u.pathname.startsWith('/be/') || u.pathname.includes('/be/api')
    if (isBackendApi) return false

    // Allow settings.json and static assets without auth
    const isSettings = /\/settings\/settings\.json$/i.test(u.pathname)
    const isStaticAsset =
      /\.(css|js|map|png|jpe?g|gif|svg|ico|woff2?|ttf|otf|json)$/i.test(
        u.pathname
      )
    return isSettings || isStaticAsset
  } catch {
    // Fallback: allow only when on public pages if URL parsing failed
    const path = typeof window !== 'undefined' ? window.location.pathname : ''
    const onPublicPage = path.includes('/landing') || path.includes('/callback')
    return onPublicPage
  }
}

export function isLandingPage() {
  return (
    typeof window !== 'undefined' &&
    window.location.pathname.includes('/landing')
  )
}
